import React, { Component } from 'react';
import { getQueryString } from 'utils';

export default class Complaint extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: getQueryString('type')
        }
    }

    setName = () => {
        const { type } = this.state;

        let name = {
            'etxgs': '儿童学古诗',
            'etxcy': '儿童学成语',
            'yyqmeg': '英语启蒙儿歌',
        }
        // console.log(name[type]);

        if (!type) {
            return '呼呼收音机'
        } else {
            return name[type]
        }
    }

    handleA1 = () => {
        window.location.href = "https://audio.huhustory.com/m1_simple/a1.e609a8c9.doc"
    }

    handleA2 = () => {
        window.location.href = "https://audio.huhustory.com/m1_simple/a2.bda96f7b.doc"
    }

    render() {
        return (<div>
            <h3 style={{
                textAlign: 'center',
                fontWeight: 'bold',
                margin: '50px 0 20px',
                fontFamily: '宋体',
                color: '#000'
            }}>{this.setName()}版权投诉指引</h3>
            <div style={{
                marginBottom: "20px",
                fontSize: '14px',
                fontFamily: '宋体',
                padding: '0 15px',
                color: '#000'
            }}>

                {this.setName()}是独立的信息存储空间服务提供者，平台内容由创作者独立制作并上传、发布。{this.setName()}作为信息存储空间服务提供者无法对创作者通过{this.setName()}上传、发布的所有作品进行事先审查。为了建立良好的平台秩序和保护权利人的合法权益，根据相关法律法规的规定，{this.setName()}特制定本指引，以保护权利人的合法权益。<br /><br />

                一、流程<br /><br />

                （一）通知{this.setName()}<br /><br />

                若权利人认为创作者上传、发布的任何节目内容侵犯其合法权益，请按以下要求提交相关材料进行投诉，通知{this.setName()}：<br /><br />

                权利人应向{this.setName()}提出书面通知书（书面通知书的内容请参考附件1模板），通知书的内容应包括但不限于以下内容：<br /><br />

                1、权利人主体信息和相关材料<br /><br />

                权利人的姓名（名称）、联系方式、地址及营业执照（单位）、身份证（个人）、相关授权证明等证明权利人主体资格的材料；<br /><br />

                2、权利人要求<br /><br />

                权利人要求删除或者断开链接的节目相关内容的准确信息（包括节目名称、创作者信息（昵称）等）和网络地址；<br /><br />

                3、投诉的具体权利类型<br /><br />

                权利人应在书面通知书中明确投诉的节目内容的具体权利类型，如改编权、汇编权、信息网络传播权、肖像权、表演者权利等。<br /><br />

                4、构成侵权的初步证明材料<br /><br />

                该初步证明材料应包括：<br /><br />

                （1）权利人拥有权利的权属证明材料：包括但不限于相关机关颁发的著作权证书、作品首次公开发表或发行日期证明材料（如作品首次公开发表的网络地址或纸质媒体扫描件等）、授权证明文件等权属证明；<br /><br />

                （2）被投诉方提供的侵权证明：包括但不限于被投诉方发布的作品相关内容构成对权利人的著作权、肖像权等侵权的有效证明材料等，如侵权截图对比等。<br /><br />

                5、权利人保证<br /><br />

                权利人的通知书应包含以下保证：权利人在通知书中的陈述和提供的相关材料皆是真实、有效和合法的，并保证承担和赔偿因{this.setName()}根据权利人的通知而删除或者断开有关侵权作品的链接或相关内容而给{this.setName()}造成的任何损失，包括但不限于{this.setName()}因向被投诉方或用户赔偿而产生的损失及{this.setName()}名誉、商誉损害等。<br /><br />

                （二）{this.setName()}转送<br /><br />

                {this.setName()}作为中立的信息存储空间服务提供者，收到权利人符合本指引要求的通知书后，{this.setName()}会尽快按照相关法律法规的规定进行处理，并在符合法律规定要求的情形下将权利人的通知书转送给被投诉方。<br /><br />

                （三）被投诉人反通知<br /><br />

                被投诉方在收到{this.setName()}转送的权利人向{this.setName()}提交的相关投诉材料后，若被投诉方不认可权利人的投诉，可以参照本指引的相关流程并在三个工作日内（逾期视为同意投诉人的投诉事实）提供反通知书及相关证明材料给{this.setName()}（侵权投诉反通知书的内容请参考附件2模板）。{this.setName()}根据被投诉人反通知情况可能会将被投诉人提供的侵权投诉反通知书及相关证明材料转送给权利人，若权利人对于被投诉方的意见及其提供的相关材料有异议的，{this.setName()}建议权利人另行通过行政投诉、民事诉讼等方式直接和被投诉方解决相关问题。如果权利人有新的并可充分推翻被投诉方意见的证明材料的，也可向{this.setName()}提供。<br /><br />

                二、联系方式<br /><br />

                1、将前述书面通知书、反通知书及其他相关证明材料的纸质版本全部扫描后通过电子邮件发送至{this.setName()}指定电子邮箱：<br /><br />

                投诉接收：huhu@hezi.com；<br /><br />

                邮件名称标明：“【侵权投诉】被投诉人+作品名称+简短侵权事实”，如“【侵权投诉】用户“甲”《ABC》信息网络传播权侵权”<br /><br />

                2、通过邮寄的方式将前述书面通知书、反通知书及其他相关证明材料的纸质版本邮寄至{this.setName()}指定的以下地点：<br /><br />

                浙江省杭州市拱墅区祥盛路12号法务部收（邮编：310012）<br /><br /><br />


                附件1：<span style={{ color: '#1890ff' }} onClick={() => this.handleA1()}>侵权投诉通知书（模板）</span><br /><br />

                附件2：<span style={{ color: '#1890ff' }} onClick={() => this.handleA2()}>侵权投诉反通知书（模板）</span><br /><br />


            </div>

        </div>);
    }
}